import axios from 'axios'


import {Message} from 'element-ui'
import router from "@/router";


let loading = null;

// 超时时间
axios.defaults.timeout = 60000
axios.defaults.withCredentials = true;  // 携带cookie
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 测试、生产环境 "production"
// 本地开发环境 "development"
axios.defaults.baseURL = '';


// // http请求拦截器
axios.interceptors.request.use(config => {
// console.log(config);
    // eslint-disable-next-line no-debugger
    // debugger
    return config
}, error => {
    Message.error({message: '加载超时'})
    return Promise.reject(error)
})


// http响应拦截器
axios.interceptors.response.use(data => {// 响应成功关闭loading

    // const isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
    // console.log('dsadasds')
    // console.log(data);
    if (data.data.status === '0') {
        return data.data
    } else if (data.data.status === '-99') {
        Message.error({message: '未登录'});
        window.localStorage.removeItem('token');
        router.replace('/');
        return data.data;
    } else {
        // // eslint-disable-next-line no-debugger
        // debugger
        if (data.data.status === '1') {
            Message.error({message: data.data['detail']});
        }
        return data.data;
    }
}, error => {
    Message.error({message: '加载失败'})
    return Promise.reject(error)
})

// let loadingInstance2;

export function get(url, params,showLoading = true) {
    return new Promise((resolve, reject) => {
        let temp = window.localStorage.getItem('token') || null

        if(showLoading){
            loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        }


        axios.get(url, {
            params: temp ? {...params, token: temp || ''} : params
        }).then(res => {
            // // eslint-disable-next-line no-debugger
            // debugger
            if(showLoading){
                loading.close()
            }
            resolve(res);
        }).catch(err => {
            if(showLoading){
                loading.close()
            }
            reject(err.data)
        })
    });
}

export function post(url, params,showLoading = true) {
    return new Promise((resolve, reject) => {
        let temp = JSON.parse(window.localStorage.getItem('loginUserInfo'))


        if(showLoading){
            loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        }

        axios.post(url, temp ? {...params, token: temp.token || ''} : params)
            .then(res => {
                if(showLoading){
                    loading.close()
                }
                resolve(res);
            })
            .catch(err => {
                if(showLoading){
                    loading.close()
                }
                reject(err)
            })
    });
}

export function postFile(url, file) {
    let param = new FormData();
    param.append('file', file);
    const cOnfig = {
        headers: {"Content-Type": "multipart/form-data;boundary=" + new Date().getTime()}
    };
    return new Promise((resolve, reject) => {
        axios.post(url, param, cOnfig)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

export default {
    get,
    post,
    postFile

}

